export const iconFontAwesomeChildhoodCakeCandles = (
	<i className="fa-solid fa-cake-candles"></i>
);
